import Articles from './Articles';
import {
  ArticlesWrapper,
  Container,
  Description,
  HeadingWrapper
} from './FAQ.styles';
import { CommonHeading } from '../Financing.styles';

type OwnProps = {
  page: string;
  urls: Map<string, number>;
};

export default function FAQ({ page, urls }: OwnProps) {
  return (
    <Container>
      <HeadingWrapper>
        <CommonHeading>We’re here to help</CommonHeading>
        <Description>
          <span className="md:whitespace-nowrap">
            Have questions about financing your car?
          </span>{' '}
          We’ve got you covered.
        </Description>
      </HeadingWrapper>
      <ArticlesWrapper>
        <Articles page={page} urls={urls} />
      </ArticlesWrapper>
    </Container>
  );
}
